export enum SchemEnum {
    Surgery = "SURGERY",
    EmergencyMedicine = "EM",
    Ophthalmology = "OPHTH",
    Radiology = "RADIOLOGY",
    SportsAndExerciseMedicine = "SEM",

}